module.exports = __webpack_public_path__ + "img/DDM26-01.8d0fcc82.jpeg";